export default {
  interviewer: [],
  errors: null
};
